/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceSettingsUpdateDto } from './PriceSettingsUpdateDto';
import {
    PriceSettingsUpdateDtoFromJSON,
    PriceSettingsUpdateDtoFromJSONTyped,
    PriceSettingsUpdateDtoToJSON,
    PriceSettingsUpdateDtoToJSONTyped,
} from './PriceSettingsUpdateDto';

/**
 * 
 * @export
 * @interface SavePriceSettingsRequestBody
 */
export interface SavePriceSettingsRequestBody {
    /**
     * 
     * @type {Array<PriceSettingsUpdateDto>}
     * @memberof SavePriceSettingsRequestBody
     */
    priceSettings: Array<PriceSettingsUpdateDto>;
}

/**
 * Check if a given object implements the SavePriceSettingsRequestBody interface.
 */
export function instanceOfSavePriceSettingsRequestBody(value: object): value is SavePriceSettingsRequestBody {
    if (!('priceSettings' in value) || value['priceSettings'] === undefined) return false;
    return true;
}

export function SavePriceSettingsRequestBodyFromJSON(json: any): SavePriceSettingsRequestBody {
    return SavePriceSettingsRequestBodyFromJSONTyped(json, false);
}

export function SavePriceSettingsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavePriceSettingsRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'priceSettings': ((json['priceSettings'] as Array<any>).map(PriceSettingsUpdateDtoFromJSON)),
    };
}

export function SavePriceSettingsRequestBodyToJSON(json: any): SavePriceSettingsRequestBody {
    return SavePriceSettingsRequestBodyToJSONTyped(json, false);
}

export function SavePriceSettingsRequestBodyToJSONTyped(value?: SavePriceSettingsRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceSettings': ((value['priceSettings'] as Array<any>).map(PriceSettingsUpdateDtoToJSON)),
    };
}

